import { h } from "vue";
import { ElMessageBox, ElNotification } from "element-plus";
import Swal from "sweetalert2";
import { swalDialogClass } from "./helper.js";
import { i18n } from "./lang/i18n";
import router from "@/router";
import { requestUrl } from "./routes.js";

const t = (key) => i18n.global.t(key);

function Alert(text) {
  ElMessageBox.confirm(text, "Alert", {
    confirmButtonText: "OK",
    showCancelButton: false,
    type: "warning",
    center: true,
  });
}

function DeleteDialog(text) {
  return Swal.fire({
    title: t("commonAreYouSure"),
    text: text,
    icon: "warning",
    showCancelButton: true,
    cancelButtonText: t("commonCancel"),
    confirmButtonText: t("commonConfirm"),
    customClass: swalDialogClass(),
    buttonsStyling: false,
  });
}

function DeleteSuccess() {
  ElNotification({
    title: "Success",
    message: t("operationSuccess"),
    type: "success",
    position: "top-right",
  });
}

export function notifyRequestSuccess({
  title = null,
  message = null,
  count = 1,
  policyId = null,
  isBulk = true,
} = {}) {
  const notifTitle = title || t("requestSuccessNotificationTitle") || "Müraciət uğurla yaradıldı";
  const rawMsg = message || (
    count > 1
      ? (t("bulkRequestSuccessNotificationMsg") || "{count} nəfər üzrə paket müraciət uğurla bazaya daxil edildi.").replace("{count}", count)
      : (t("bulkRequestSuccessNotificationMsg") || "Müraciət paketi uğurla bazaya daxil edildi.")
  );

  const currentPolicyId = policyId || (function () {
    try {
      return JSON.parse(sessionStorage.getItem("policy")) || null;
    } catch {
      return null;
    }
  })();

  let notifInstance = null;

  const msgVNode = h("div", { class: "app-notif-body" }, [
    h("p", { class: "app-notif-text mb-2" }, rawMsg),
    h(
      "button",
      {
        type: "button",
        class: "app-notif-action-btn",
        onClick: () => {
          if (notifInstance && typeof notifInstance.close === "function") {
            notifInstance.close();
          }
          window.dispatchEvent(new CustomEvent("app:refresh-data", { detail: { isBulk } }));
          if (currentPolicyId) {
            router.push(requestUrl(currentPolicyId)).catch(() => {});
          } else {
            router.push("/request").catch(() => {});
          }
        },
      },
      [
        h("i", { class: "bi bi-arrow-right-circle me-1" }),
        h("span", t("viewRequestsAction") || "Müraciətlərə bax"),
      ]
    ),
  ]);

  notifInstance = ElNotification({
    title: notifTitle,
    message: msgVNode,
    type: "success",
    position: "top-right",
    duration: 6500,
    customClass: "app-top-notification",
  });

  // Notify any active table listener
  window.dispatchEvent(new CustomEvent("app:refresh-data", { detail: { isBulk } }));

  return notifInstance;
}

export default {
  Alert,
  DeleteDialog,
  DeleteSuccess,
  notifyRequestSuccess,
};
